import { render, staticRenderFns } from "./serveTab5.vue?vue&type=template&id=7665dac0&scoped=true"
import script from "./serveTab5.vue?vue&type=script&lang=js"
export * from "./serveTab5.vue?vue&type=script&lang=js"
import style0 from "./serveTab5.vue?vue&type=style&index=0&id=7665dac0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7665dac0",
  null
  
)

export default component.exports